import {
  ThreadActivityTopRepliesEdgeFields_node,
  ThreadActivityTopRepliesEdgeFields_node_sender,
  ThreadActivityTopRepliesEdgeFields_node_sender_AnonymousUser,
  ThreadActivityTopRepliesEdgeFields_node_sender_User,
  UserFieldsWithViewerIsFollowing,
} from '@ms/yammer-graphql';

import { ViewerIsFollowingUser } from '../../../state/types';

interface SenderFollowing {
  readonly viewerIsFollowing: boolean;
}

export const processViewerIsFollowingUser: (value: UserFieldsWithViewerIsFollowing) => ViewerIsFollowingUser = (
  value
) => ({
  id: value.id,
  isFollowing: value.viewerIsFollowing,
});

export const processViewerIsFollowingUserSender: (
  value: ThreadActivityTopRepliesEdgeFields_node
) => ViewerIsFollowingUser = (value) => ({
  id: value.sender.id,
  isFollowing: processSenderFollowing(value.sender).viewerIsFollowing,
});

const processSenderFollowing: (
  value:
    | ThreadActivityTopRepliesEdgeFields_node_sender
    | ThreadActivityTopRepliesEdgeFields_node_sender_AnonymousUser
    | ThreadActivityTopRepliesEdgeFields_node_sender_User
) => SenderFollowing = (value) => ({
  viewerIsFollowing: 'viewerIsFollowing' in value ? value.viewerIsFollowing : false,
});
